import React from "react";

interface IProps {
	type: string | null;
	style?: React.CSSProperties;
	ariaLabel?: string | "";
}

const FallbackImage: React.FunctionComponent<IProps> = ({ type, style , ariaLabel}) => {
	const t = type || "other";
	return (
		<img
			style={style}
			src={`/dist/images/fallbacks/${t}.svg`}
			aria-label={ariaLabel}
		></img>
	);
};

// src={require(`/dist/images/fallbacks/${t}.svg`).default}

export default FallbackImage;
